import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import { getProductMetafieldValue } from "~/lib/shopify/constants"

/**
 * The function returns true if the product is a bundle or if it has multiple prices, otherwise it
 * returns false.
 * @param {boolean} `isProductBundle` - a boolean value indicating whether the product is a bundle or not.
 * @param {UnlikelyProduct} `product` - the product object.
 * @returns a boolean value.
 */
export function getHasMultiplePrices({
  isProductBundle,
  product,
}: {
  isProductBundle: boolean
  product: UnlikelyProduct
}): boolean {
  const BUNDLE_HIDE_FROM_PRICE_LABEL = product?.metafields
    ? getProductMetafieldValue(product.metafields, "BUNDLE_HIDE_FROM_PRICE_LABEL") === "true"
    : false

  return !isProductBundle
    ? product.priceRange?.minVariantPrice?.amount !== product.priceRange?.maxVariantPrice?.amount
    : BUNDLE_HIDE_FROM_PRICE_LABEL
    ? false
    : true
}
